import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { SharedService } from 'src/app/core/Services/shared.service';
import { LocationService } from '../../Services/location.service';
import { RBLocation } from '../../Models/Location';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { NotificationService } from 'src/app/core/Services/notification.service';
import { VERBIAGE } from 'src/app/config';
import { Router } from '@angular/router';

@Component({
    selector: 'location-list',
    templateUrl: './location-list.component.html'
})

export class LocationListComponent implements OnInit, OnDestroy {

    Locations: MatTableDataSource<RBLocation>;
    columns: string[] = ['locationName', 'city', 'state', 'zipCode', 'regionName', 'isRegional', 'options'];
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sorting: MatSort;

    constructor(
        private _shared: SharedService, private _location: LocationService,
        private _notify: NotificationService, private _router: Router
    ) {
        // Setting up page title
        this._shared.pageTitle = 'Locations';

        // Show loader
        this._shared.loadingState = true;

        // Display and subscribe to search
        this._shared.displaySearchBox.next(true);
        this._shared.searchString.subscribe(res => {
            if (this.Locations) { this.Locations.filter = res; }
        });
    }

    ngOnInit() {
        // Call location service for getting location list.
        this._location.getLocations().subscribe(res => {
            this.Locations = new MatTableDataSource<RBLocation>(res['result']);
            setTimeout(() => {
                this.Locations.paginator = this.paginator;
                this.Locations.sort = this.sorting;
                this._shared.loadingState = false;
            });
        });
    }

    archiveServiceCenter(location: RBLocation) {
        const _this = this;
        // Prompt user before archive.
        let body = (location.isRegional === 'Y') ? VERBIAGE.REGIONAL_SERVICE_CENTER_DELETE : VERBIAGE.SERVICE_CENTER_DELETE;
        this._notify.openDialog({
            color: 'warn', title: VERBIAGE.ARCHIVE_SERVICE_CENTER_TITLE, body, handlers: [
                { color: 'warn', text: 'Confirm', type: '-raised-', action() {                    
                    // Archiving location in DB
                    _this._location.archiveServiceCenter(location.locationID, location.isRegional).subscribe(res => {
                        if (res['status'] === 'OK') {
                            // On success removing location from Locatoins List.
                            const index = _this.Locations.data.findIndex(x => x.locationID === location.locationID);
                            _this.Locations.data.splice(index, 1);
                            _this.Locations.paginator = _this.paginator;
                            _this._notify.toastMessage({
                                color: 'warn', message: VERBIAGE.ARCHIVE_UPDATE_MESSAGE, duration: 3000
                            });

                            if (location.isRegional === 'Y') {
                                // virtual reload
                                _this._router.navigateByUrl('/dashboard', {skipLocationChange: true}).then(() => {
                                    _this._router.navigate(['/dashboard/locations']);
                                });
                            }
                        }
                    });
                }},
                { text: 'Cancel', type: '-raised-' }
            ]
        });
    }

    ngOnDestroy() {
        // Hide search box
        this._shared.displaySearchBox.next(false);
    }
}